import $ from 'jquery';
import Component from './component';
import createComponentFactory from '../createComponent';


class HomeBrandList extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.$element = $(element);
    this.$item = $('.home-brandList__item')
    this.$bg = $('.home-areaFeatureBrand__bg')

    this._handleTriggerMouseenter = this._handleTriggerMouseenter.bind(this);
    this._handleTriggerMouseleave = this._handleTriggerMouseleave.bind(this);
  }

  _addEvents() {
    this.$element.find('.home-brandList__link')
      .on('mouseenter', this._handleTriggerMouseenter)
      .on('mouseleave', this._handleTriggerMouseleave);
  }

  _removeEvents() {

  }

  _handleTriggerMouseenter(evt) {
    evt.preventDefault();

    let num = this.$item.index($(evt.currentTarget).parents('.home-brandList__item'));

    this.$bg
      .removeClass('home-areaFeatureBrand__bg--show')
      .eq(num)
        .addClass('home-areaFeatureBrand__bg--show')
  }

  _handleTriggerMouseleave(evt) {
    evt.preventDefault();

    this.$bg
      .removeClass('home-areaFeatureBrand__bg--show')
  }

  didRegisterComponent() {
    this._addEvents();
  }

  didUnregisterComponent() {
    this._removeEvents();
  }

}


export default createComponentFactory(HomeBrandList);





// WEBPACK FOOTER //
// ./src/js/app/component/homeBrandList.js